import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faTerminal,
    faUserTie,
    faBalanceScaleLeft,
    faUser,
    faUsers,
    faShareAltSquare,
    faUserCog,
    faUserLock,
    faAddressBook,
    faFilter,
    faUserAlt,
    faUserAltSlash,
    faKey,
    faSatelliteDish,
    faWifi,
    faEllipsisH,
    faRulerHorizontal,
    faRuler,
    faClock,
    faLanguage,
    faHome,
    faHdd,
    faStar,
    faFilePdf,
    faFileUpload,
    faCheck,
    faCheckCircle,
    faBan,
    faTools,
    faToolbox,
    faExclamation,
    faTimesCircle,
    faChartBar,
    faChartPie,
    faInfo,
    faTruck,
    faMapMarkedAlt,
    faMapMarkerAlt,
    faTachometerAlt,
    faWeightHanging,
    faLaptopCode,
    faMicrochip,
    faTh,
    faThList,
    faBriefcase,
    faLock,
    faGlobeAmericas,
    faEnvelope,
    faBroom,
    faSmog,
    faSatellite,
    faMonument,
    faAngleDoubleDown,
    faAngleLeft,
    faChevronUp,
    faChevronDown
} from "@fortawesome/free-solid-svg-icons";

import {
    faAddressCard
}
    from "@fortawesome/free-regular-svg-icons"

(library).add(
    faTerminal,
    faUserTie,
    faBalanceScaleLeft,
    faUser,
    faUsers,
    faShareAltSquare,
    faUserCog,
    faUserLock,
    faAddressBook,
    faAddressCard,
    faFilter,
    faUserAlt,
    faUserAltSlash,
    faKey,
    faSatelliteDish,
    faWifi,
    faEllipsisH,
    faRulerHorizontal,
    faRuler,
    faClock,
    faLanguage,
    faHome,
    faHdd,
    faStar,
    faFilePdf,
    faFileUpload,
    faCheck,
    faBan,
    faTools,
    faToolbox,
    faExclamation,
    faTimesCircle,
    faCheckCircle,
    faChartBar,
    faChartPie,
    faInfo,
    faTruck,
    faMapMarkedAlt,
    faMapMarkerAlt,
    faTachometerAlt,
    faWeightHanging,
    faLaptopCode,
    faMicrochip,
    faTh,
    faThList,
    faBriefcase,
    faLock,
    faGlobeAmericas,
    faEnvelope,
    faBroom,
    faSmog,
    faSatellite,
    faMonument,
    faAngleDoubleDown,
    faAngleLeft,
    faChevronUp,
    faChevronDown
)
